export const initialQuestions = {
  "A1.1": {
    id: "A1.1",
    question:
      "I carry out guidance work in accordance with legislation and administrative instruction of my field.",
    answer: null,
    goal: null,
  },
  "A1.2": {
    id: "A1.2",
    question:
      "I am aware of the boundaries of my profession and competency and act accordingly.",
    answer: null,
    goal: null,
  },
  "A1.3": {
    id: "A1.3",
    question: "I act in accordance with the ethical principles of my field.",
    answer: null,
    goal: null,
  },
  "A1.4": {
    id: "A1.4",
    question:
      "In guidance relationship, I act in in accordance with the ethical principles of my field.",
    answer: null,
    goal: null,
  },
  "A2.1": {
    id: "A2.1",
    question: "I base my work on key theories and research data in the field.",
    answer: null,
    goal: null,
  },
  "A2.2": {
    id: "A2.2",
    question: "I apply a wide range of theories in guidance work.",
    answer: null,
    goal: null,
  },
  "A2.3": {
    id: "A2.3",
    question:
      "I follow research and other literature in the field of guidance, as well as publications by collaborative partners and disciplines relevant to my work.",
    answer: null,
    goal: null,
  },
  "A3.1": {
    id: "A3.1",
    question:
      "I evaluate and develop my guidance work together with clients, colleagues, various actors in guidance and stakeholders.",
    answer: null,
    goal: null,
  },
  "A3.2": {
    id: "A3.2",
    question:
      "I am committed to identifying my own development goals and pursuing continuous professional development.",
    answer: null,
    goal: null,
  },
  "A4.1": {
    id: "A4.1",
    question:
      "I use oral, written, and visual communication in a clear and understandable manner.",
    answer: null,
    goal: null,
  },
  "A4.2": {
    id: "A4.2",
    question:
      "I utilise different channels, methods and tools in communication and interaction.",
    answer: null,
    goal: null,
  },
  "A4.3": {
    id: "A4.3",
    question:
      "I master spoken and written communication, both real-time and delayed, creating and maintaining dialogues with the client/groups.",
    answer: null,
    goal: null,
  },
  "A4.4": {
    id: "A4.4",
    question:
      "I communicate as a professional in client work and as a representative of the guidance sector in different networks and working groups.",
    answer: null,
    goal: null,
  },
  "A5.1": {
    id: "A5.1",
    question: "I utilise technology in guidance efficiently and appropriately.",
    answer: null,
    goal: null,
  },
  "A5.2": {
    id: "A5.2",
    question: "I utilise technology seamlessly in the guidance process.",
    answer: null,
    goal: null,
  },
  "A5.3": {
    id: "A5.3",
    question:
      "I promote the collaborative use of technology in the guidance process and professional cooperation.",
    answer: null,
    goal: null,
  },
  "A5.4": {
    id: "A5.4",
    question:
      "I utilise new technological solutions and promote their use in the guidance process.",
    answer: null,
    goal: null,
  },
  "B1.1": {
    id: "B1.1",
    question:
      "Alongside the individual´s own development, I regard guidance as a service process and social activity.",
    answer: null,
    goal: null,
  },
  "B1.2": {
    id: "B1.2",
    question:
      "I take into account the information, interaction, and process dimensions of guidance.",
    answer: null,
    goal: null,
  },
  "B1.3": {
    id: "B1.3",
    question:
      "Together with the client, I systematically evaluate the results and impact of the guidance process.",
    answer: null,
    goal: null,
  },
  "B2.1": {
    id: "B2.1",
    question:
      "I examine guidance from the individual´s perspective separately as a development process, life situation and its contexts.",
    answer: null,
    goal: null,
  },
  "B2.2": {
    id: "B2.2",
    question:
      "I examine career development within the framework of an individual´s characteristics, interests, and values, and context.",
    answer: null,
    goal: null,
  },
  "B2.3": {
    id: "B2.3",
    question:
      "I examine my work as part of the social and cultural reality affecting the client’s situation.",
    answer: null,
    goal: null,
  },
  "B2.4": {
    id: "B2.4",
    question:
      "I apply guidance theories, taking into account of the individual and their context in a client-oriented manner.",
    answer: null,
    goal: null,
  },
  "B2.5": {
    id: "B2.5",
    question:
      "I ensure that clients and groups learn to assess and develop their strengths and competency in relation to the opportunities provided by the operating environment.",
    answer: null,
    goal: null,
  },
  "B2.6": {
    id: "B2.6",
    question:
      "I examine my own and the client´s worldview as conceptualisation, awareness, and as structuring one´s interpretation of reality.",
    answer: null,
    goal: null,
  },
  "B3.1": {
    id: "B3.1",
    question:
      "I ensure that clients, groups, and I myself have access to up-to-date sources of information to support plans and decisions concerning life, studies, and work.",
    answer: null,
    goal: null,
  },
  "B3.2": {
    id: "B3.2",
    question:
      "I screen the client´s or group´s readiness and guidance needs and set the goals of the guidance process together with the client or group members.",
    answer: null,
    goal: null,
  },
  "B3.3": {
    id: "B3.3",
    question:
      "I plan and implement together with clients a guidance process that meets their readiness and needs.",
    answer: null,
    goal: null,
  },
  "B3.4": {
    id: "B3.4",
    question:
      "Together with the client, I evaluate the results and impact of the guidance process.",
    answer: null,
    goal: null,
  },
  "C1.1": {
    id: "C1.1",
    question:
      "In my work, I take into account phenomena, relationships, trends and changes between education, working life and society.",
    answer: null,
    goal: null,
  },
  "C1.2": {
    id: "C1.2",
    question:
      "I ensure that lifelong guidance services form a continuum at the core of lifelong and continuous learning.",
    answer: null,
    goal: null,
  },
  "C1.3": {
    id: "C1.3",
    question:
      " I follow current research and participate in societal discussion related to the field.",
    answer: null,
    goal: null,
  },
  "C2.1": {
    id: "C2.1",
    question:
      "I apply organisational and networking theories in defining jointly agreed objectives of guidance and in planning, implementing, and evaluating services.",
    answer: null,
    goal: null,
  },
  "C2.2": {
    id: "C2.2",
    question:
      "I develop guidance as part of a broader societal context and the service structure of different organisations.",
    answer: null,
    goal: null,
  },
  "C3.1": {
    id: "C3.1",
    question: "I cooperate multiprofessionally with other professionals.",
    answer: null,
    goal: null,
  },
  "C3.2": {
    id: "C3.2",
    question: "I cooperate with various organisations.",
    answer: null,
    goal: null,
  },
  "C4.1": {
    id: "C4.1",
    question:
      "I plan and organise guidance work in accordance with local needs and operating conditions, and with  administrative guidelines and regulations.",
    answer: null,
    goal: null,
  },
  "C4.2": {
    id: "C4.2",
    question:
      "I promote the systematic assessment of the quality and impact of guidance.",
    answer: null,
    goal: null,
  },
  "C4.3": {
    id: "C4.3",
    question:
      "I examine the underpinning principles, values, perceptions, structures, policies, and practical operating conditions for guidance.",
    answer: null,
    goal: null,
  },
};
export const structure = [
  {
    id: "A",
    header: "Professionalism",
    subheaders: [
      {
        id: "A1",
        subheader: "Ethical competency",
        questions: ["A1.1", "A1.2", "A1.3", "A1.4"],
      },
      {
        id: "A2",
        subheader: "Theory- and research-based competency",
        questions: ["A2.1", "A2.2", "A2.3"],
      },
      {
        id: "A3",
        subheader: "Reflective competency",
        questions: ["A3.1", "A3.2"],
      },
      {
        id: "A4",
        subheader: "Communication and interaction competency",
        questions: ["A4.1", "A4.2", "A4.3", "A4.4"],
      },
      {
        id: "A5",
        subheader: "Digital competency",
        questions: ["A5.1", "A5.2", "A5.3", "A5.4", "A5.5"],
      },
    ],
  },
  {
    id: "B",
    header: "Client work",
    subheaders: [
      {
        id: "B1",
        subheader: "Process competency",
        questions: ["B1.1", "B1.2", "B1.3"],
      },
      {
        id: "B2",
        subheader: "Guidance and learning theories",
        questions: ["B2.1", "B2.2", "B2.3", "B2.4", "B2.5", "B2.6"],
      },
      {
        id: "B3",
        subheader: "Methodological competency",
        questions: ["B3.1", "B3.2", "B3.3", "B3.4"],
      },
    ],
  },
  {
    id: "C",
    header: "Systemic competency",
    subheaders: [
      {
        id: "C1",
        subheader: "Lifelong guidance",
        questions: ["C1.1", "C1.2", "C1.3"],
      },
      {
        id: "C2",
        subheader: "Systems theory competency",
        questions: ["C2.1", "C2.2"],
      },
      {
        id: "C3",
        subheader: "Networking competency",
        questions: ["C3.1", "C3.2"],
      },
      {
        id: "C4",
        subheader: "Strategic competency",
        questions: ["C4.1", "C4.2", "C4.3"],
      },
    ],
  },
];

export const levelDescriptions = {
  0: {
    header: "Competency level 0",
    content:
      "I do not yet have competency in this area yet. I have recently been assigned responsibilities that includes the competency in question, or I am not required to apply or demonstrate this competency in my work.",
  },
  1: {
    header: "Competency level 1",
    content:
      "I have the basic knowledge required for the job within the competency area. I have achieved at least this level in initial training in the field.",
  },
  2: {
    header: "Competency level 2",
    content:
      "I have a solid knowledge base of the competency area and apply it in a versatile way in my everyday practice.",
  },
  3: {
    header: "Competency level 3",
    content:
      "I have a comprehensive knowledge and understanding of the competency area. I comprehend topics broadly, think and act creatively, and develop and identify new solutions and operating modes within this competency area.",
  },
};
export const questionInformation = {
  "A1.1": {
    id: "A1.1",
    header: "Legal and administrative requirements",
    text: "Career professionals carry out guidance work and produces guidance services in accordance with the legislation and administrative regulations in their field.",
    tunnistaa_ja_ymmartaa: [
      "the essential legislation concerning guidance and its operational context",
      "legislation on equality and non-discrimination",
      "the up-to-date content of the legislation, administrative regulations, and basic concepts in their field",
      "internal policies and operating instructions of their organisation",
      "international agreements which Finland is committed to and which relate to the organisation of guidance",
    ],
    osaa: [
      "carry out guidance work and provide guidance services in accordance with up-to-date legislation and administrative regulations concerning their field",
      "act in accordance with the ethical principles of their field",
      "document client processes appropriately while ensuring the protection of client data",
    ],
  },
  "A1.2": {
    id: "A1.2",
    header: "Professional responsibility",
    text: "Career professionals are aware of the boundaries of their profession and competency and acts accordingly.",
    tunnistaa_ja_ymmartaa: [
      "the boundaries of their profession, professionalism, and competency",
      "possible situations and factors in which the boundaries of one's profession and one's competency might be reached",
      "the importance of one's own working ability and well-being",
    ],
    osaa: [
      "act in accordance with ethical principles in their work",
      "maintain a professional interaction between career professional and client",
      "describe their expertise and its boundaries to the client",
      "operate within the boundaries of their profession and competency",
      "consult representatives of other professional groups when the client's situation so requires",
      "refer the client to the services provided by another professional group if necessary",
      "document the procedures and decisions agreed with the client",
      "clearly state in communication when they’re acting in their capacity as a professional and when as a private person",
      "take care of their well-being and ability to work",
    ],
  },
  "A1.3": {
    id: "A1.3",
    header: "Ethical principles",
    text: "Career professionals act in accordance with the ethical principles of their field.",
    tunnistaa_ja_ymmartaa: [
      "the ethical and philosophical principles of guidance",
      "the ethical essence of guidance work",
      "the content of the work, service channels and situations where ethical questions may arise",
      "their personal values, concepts of humanity and ethicality",
      "key international and national ethical guidelines and principles in their field ",
      "the time and context constraints of theories, approaches and forms of work and their applicability to the respective guidance process",
      "factors influencing ethical consideration from the perspectives of different parties",
      "bias issues related to the job and the operating environment",
    ],
    osaa: [
      "act professionally in accordance with international and national ethical principles in the field",
      "critically evaluate their activities as career professionals and acknowledge how their values, understanding of humanity and ethical thinking are impacting their work",
      "assess the applicability of the theories, approaches and forms of work used to the respective guidance process",
      "work in a way that the client's interests are at the centre of operations",
      "act in their work promoting equity, equality and justice",
      "use collegial discussions to support ethical considerations",
      "consult the appropriate experts in case of solution requiring ethical considerations",
      "examine the risks and benefits of different options",
      "independently make ethically justified decisions in their work",
      "bring forward ethically justified perspectives in organisation´s guidance work",
      "make initiatives to promote ethical reflection and action within their professional networks",
    ],
  },
  "A1.4": {
    id: "A1.4",
    header: "Guidance relationship",
    text: "Career professionals act according to ethical principles in the guidance relationship",
    tunnistaa_ja_ymmartaa: [
      "the diversity of clients and their different backgrounds (needs, functional capacity, abilities, competency, circumstances, values, culture, gender identity, religion, etc.)",
      "conflicts of interest that may affect the objectivity of the career professional during a guidance process",
      "legislation regarding the recording and storage of client-related data as well as their organisation’s directives and operational policies",
    ],
    osaa: [
      "ensure that their client is aware of their legal rights and responsibilities",
      "act in accordance with the ethical professional principles in situations of conflicts of interest",
      "act accordingly in situations where a client raises concerns that the career professional is not adhering to ethical principles in their work",
      "promote accessibility and equality in their work",
      "explain to clients the rationale and basic principles of storing their information",
      "inform clients where their information is stored, how it is protected and how long it is going to be preserved",
      "ensure that the client gives their permission to store the necessary information",
      "ensure that the client gives their permission for their information to be shared between different actors if necessary",
    ],
  },
  "A2.1": {
    id: "A2.1",
    header: "Theoretical knowledge",
    text: "Career professionals base their work on the key theories and research data of the field. Through theoretical knowledge, career professionals can also perceive the goals of their guidance work and what approaches can be used to achieve them.",
    tunnistaa_ja_ymmartaa: [
      "the multidisciplinary knowledge base in the field of guidance that includes different disciplines and perspectives",
      "key theories in the field of guidance and their different approaches",
      "key theories and approaches of disciplines related to guidance work",
    ],
    osaa: [
      "describe the multidisciplinary knowledge base of the field of guidance",
      "describe the basics of the key theories in the field of guidance and their application in guidance work",
      "describe the key theories of different disciplines related to the field of guidance and their significance in guidance work",
      "be informed about developments regarding the theoretical research in the field",
    ],
  },
  "A2.2": {
    id: "A2.2",
    header: "Applying theoretical knowledge",
    text: "Career professionals apply a wide range of theories in their guidance work. Career professionals select the most appropriate theories, approaches and work methods for the client's situation.",
    tunnistaa_ja_ymmartaa: [
      "the key theories and approaches in the field and their underpinning principles based on research",
      "the theoretical basis of chosen forms of work, approaches and interventions and how to apply them in client work",
    ],
    osaa: [
      "integrate the theoretical frameworks of guidance seamlessly into their work",
      "describe how they apply theoretical knowledge in their work",
      "describe the basis of the fundamental theories in their field from which to choose the most appropriate working methods for the client's situation",
      "use their theoretical knowledge to form an applicable theory of use on which to base their work",
      "collect sufficient information about the situation of their clients and the groups to choose the most appropriate approaches and forms of work ",
      "choose the most appropriate theory-based approaches and forms of work",
      "evaluate and, if necessary, update their approaches and working methods based on the latest research",
    ],
  },
  "A2.3": {
    id: "A2.3",
    header: "Research in the field of guidance",
    text: "Career professionals follow research and literature in the field of guidance as well as publications by parties and disciplines relevant to their work. Keeping up with the research is closely linked to other competencies and the continuous development of one's professional competency.",
    tunnistaa_ja_ymmartaa: [
      "the most relevant and comprehensive sources of information in the field of guidance, as well as research organisations and communities that produce relevant information to the field ",
    ],
    osaa: [
      "obtain research-based information relevant to their work ",
      "assess research-based information’s applicability to their work",
      "apply research-based information in their work and in the planning, implementation and evaluation of guidance services",
      "promote the production, planning and implementation of relevant research material concerning their work and its operating conditions ",
      "apply research-based approach and basic research methods in developing their work",
      "share the acquired research-based information with colleagues and collaborative partners",
    ],
  },
  "A3.1": {
    id: "A3.1",
    header: "Reflective professional practice",
    text: "Career professionals critically evaluate, refine, and renew their work in collaboration with clients, colleagues, various actors in guidance and stakeholders.",
    tunnistaa_ja_ymmartaa: [
      "underpinning principles and features of critical reflection",
      "underpinning conceptions, values and attitudes as well as thinking and operating models related to working as a career professional",
      "the boundaries of their profession and competency",
      "the background and societal basis for organising guidance ",
      "the systemic nature of guidance ",
    ],
    osaa: [
      "evaluate the ethical, theoretical, and philosophical principles behind their activities and their impact on guidance work",
      "critically examine their activities in different guidance relationships and guidance-related processes in accordance with the ethical guidelines and principles of the field",
      "assess the development of their competency and professional identity, and identify their strengths and areas for development",
      "identify and evaluate the outcomes and impact of their activities from the perspective of the individual, the guidance process, and their organisation and the wider society",
      "critically evaluate and renew their work in cooperation with clients, various collaborative partners and stakeholders",
      "describe the role and locus of guidance as part of the basic task of their own organisation and policy sector",
    ],
  },
  "A3.2": {
    id: "A3.2",
    header: "Developing personal competency",
    text: "Career professionals commit to identifying their personal areas of development and to continuous improvement of their professional expertise.",
    tunnistaa_ja_ymmartaa: [
      "the importance of lifelong learning and continuous professional development in their work",
      "goals, contents and areas related to their work as well as competency requirements",
      "the potential of current and future technologies in guidance work",
      "further education and training relevant to their professional development     ",
      "funding opportunities that allow focusing on developing their competency",
      "factors affecting their work ability and well-being",
    ],
    osaa: [
      "critically evaluate their and the work community's guidance activities in relation to changes and megatrends in their operating environment",
      "assess the impacts of legislation, the operating environment and the organisation's policies and operating instructions from the perspective of their work",
      "update their job description and competency to meet any changes affecting their work",
      "assess the potential of current and future technologies and their use in their work",
      "evaluate their performance and identify their strengths and areas for development",
      "create and maintain a personal development plan",
      "apply for further education and training that supports the development of their competency",
      "develop their work based on feedback from clients and other professionals",
      "assess the development of their competency and professional expertise",
      "share their experiences within their professional networks and participate in professional discussions in the field",
      "assess and promote their work ability and well-being",
    ],
  },
  "A4.1": {
    id: "A4.1",
    header: "Clear communication",
    text: "Career professionals use oral, written and visual communication in clear and easy-to-understand way. They communicate in a transparent and accessible manner in different interaction situations and are able to take into account the clients' different abilities to receive and understand the career professional's communication.",
    tunnistaa_ja_ymmartaa: [
      "the importance of accessibility in communication",
      "factors promoting and limiting effective communication",
      "the importance of multiliteracy in their work",
      "possibilities and limitations of different communication channels",
      "the potential impact of varying background factors of career professionals and clients (e.g. language, values, culture, life experiences, ability to study) on communication",
      "the principles for culturally conscious communication",
      "the importance of verbal and nonverbal communication",
      "an appropriate and clear writing style and the importance of text formatting",
      "the importance of visual communication in guidance work",
    ],
    osaa: [
      "use appropriate language and communication channels with clients and groups",
      "take into account the interaction skills and readiness of clients of different ages ",
      "adjust the tone, speed and intensity of their use of language",
      "ensure that non-verbal communication, such as gestures and facial expressions, supports and complements verbal communication",
      "avoid using difficult-to-understand language, abbreviations or professional terms in communication",
    ],
  },
  "A4.2": {
    id: "A4.2",
    header: "Goal-oriented interaction",
    text: "Career professionals utilise various channels, methods and tools in communication and interaction.",
    tunnistaa_ja_ymmartaa: [
      "the differences between professional interaction and informal communication",
      "the possibilities and limits of professional interaction in guidance",
      "that their orientation to the interaction and communication situation lays the foundation for a goal-oriented guidance process",
      "factors that either promote or limit active message reception",
      "the potential impact of different backgrounds of career professionals and clients (e.g. language, language register, values, culture, life experiences) on mutual communication and interpretation of the meanings of messages",
      "the importance of verbal and nonverbal communication",
      "the importance of using different types of questions throughout the guidance process",
    ],
    osaa: [
      "create a multichannel, accessible, functional, and efficient guidance situation, process and environment according to the client's needs",
      "act in an interactive situation where the goals of the guidance process are at the core",
      "creates a confidential guidance relationship and maintains it through interaction",
      "actively receive messages from another person or group members",
      "clarify spoken and written language where necessary",
      "form an understanding of the communication of the client or group members",
      "reflect on what the client or group wishes to communicate",
      "avoid making interpretations based on assumptions",
      "ensure that their verbal and non-verbal communication remains consistent ",
      "conveys sensitivity, interest and attentiveness in individual guidance and group situations",
      "enhance interaction and joint knowledge formation",
      "promote the formation of shared understanding, as well as mutual trust and acceptance",
      "take into account the non-verbal communication of the client or the group and react to it accordingly",
      "respect the personal physical space of others and maintain the necessary distance in the interaction",
    ],
  },
  "A4.3": {
    id: "A4.3",
    header: "Reflexive communication",
    text: "Career professionals know how to communicate through verbal and literary means as well as in real time and in a delayed manner, enabling the dialogue between them and their clients or groups. The same principles apply to all professional interaction situations in which the career professionals participate.",
    tunnistaa_ja_ymmartaa: [
      "the importance of reflexive communication in processes involving reflection, change and development of clients and groups",
      "the effects of different question formats on the guidance process, the activities of clients and groups, and experiences in guidance situations",
      "the effects of different interventions on the guidance process and the achievement of goals",
      "the significance of their and the client's thinking, actions, emotions, and background assumptions in guidance",
      "the impact of culture, growth environment and the surrounding society on an individual's way of thinking and actions",
      "the importance of critical reflection in interaction situations",
    ],
    osaa: [
      "interpret the changing world around them and perceive its cultural diversity",
      "utilise appropriate questions and means of interaction with the client or group",
      "confirm to the client that they have understood their message and perspective",
      "summarise the content of dialogue with the client",
      "provide guidance in interaction with clients to examine their thoughts, feelings and behaviour and to promote their self-knowledge ",
      "use guidance-related methods and tools of interaction, such as clarifica-tion, mirroring, feedback, targeting and summarising in addition to dif-ferent question forms",
      "appropriately use confrontation in situations where it can promote reflection and achievement of goals by the client or group",
      "focus on the interaction situation and take into account factors that may encourage or disturb the client's or group's focus",
    ],
  },
  "A4.4": {
    id: "A4.4",
    header: "Professional communication",
    text: "Career professionals communicate as experts in, for example, client work or the collaborative reflection of guidance issues in different networks. They may also represent the professional field in teaching, public information events, publications, as a member of working groups and in collegial and multisectoral cooperation.",
    tunnistaa_ja_ymmartaa: [
      "the importance of appropriate presentation style and content formatting depending on the context and target audience",
      "the significance of the backgrounds and different perspectives of the people in interaction",
      "the significance of societal interaction for the core task of guidance",
    ],
    osaa: [
      "work with diverse people and maintain professional relationships and networks",
      "act as a representative of their professional field and organisation in communication situations",
      "summarise both the guidance process and joint discussions",
      "choose the main priorities of the issue they are presenting",
      "define the goal and content of their message according to the target audience",
      "present issues in a convincing way in different public contexts",
      "actively participate in collaborative work in accordance with the agreements made with the parties involved",
      "promote and develop their communications so that working in groups in their work community and multisectoral networks is goal-oriented, functional and efficient",
    ],
    context_competencies: [
      {
        context: "Basic education",
        tunnistaa_ja_ymmartaa: [
          "the importance of the communication and interaction competency required in multisectoral and multiprofessional collaboration and when collaborating with guardians and employers",
          "the skills and readiness of pupils of different ages and backgrounds to interact and receive communication and information",
        ],
        osaa: [
          "plan and carry out lessons, group and interaction situations and communication, taking into account the skills and readiness of pupils of different ages and backgrounds",
          "act in multisectoral, multiprofessional and interaction situations with guardians and employers",
          "clearly describe to pupils and guardians the contents and availability of guidance and student welfare services",
        ],
      },
      {
        context: "Secondary education",
        tunnistaa_ja_ymmartaa: [
          "the importance of the communication and interaction competency required in multisectoral, multiprofessional collaboration and when collab-orating with guardians and employers",
          "the skills and readiness of students of different ages and backgrounds to interact and receive communication and information",
          "the principles and ethical issues concerning the marketing of education",
        ],
        osaa: [
          "plan and carry out lessons, group and interaction situations and communication, taking into account the skills and readiness of students of different ages and backgrounds",
          "act in multisectoral, multiprofessional and interaction situations with guardians and employers",
          "clearly describe to students, guardians and partners the content and availability of guidance and support services",
          "present the activities and training programmes of the educational institution in a versatile and clear manner",
          "take into account the different readiness of target groups to respond to different marketing approaches",
        ],
      },
      {
        context: "Higher education",
        tunnistaa_ja_ymmartaa: [
          "the importance of communication and interaction competency required for multisectoral and multiprofessional cooperation in their work",
          "the skills and readiness of students of different ages and backgrounds to interact and receive communication and information",
          "principles and ethical issues concerning the marketing of education programmes",
        ],
        osaa: [
          "plan and implement interaction situations and communication, taking into account the skills and capabilities of students of different ages and backgrounds",
          "act in multisectoral and multiprofessional interaction situations",
          "clearly describe to students and other professionals the content and availability of guidance and support services",
          "present the activities and educational programmes of the educational institution in a versatile and clear way",
          "take into account the different readiness of marketing target groups to receive the message",
        ],
      },
      {
        context: "Employment services",
        tunnistaa_ja_ymmartaa: [
          "the importance of communication and interaction competency required for multisectoral, multiprofessional and working life cooperation in their work",
          "the skills and readiness of clients of different ages and backgrounds to interact and receive communication and information",
        ],
        osaa: [
          "plan and implement interaction situations and communication, taking into account the skills and capabilities of clients of different ages and types",
          "act in multisectoral and multiprofessional interaction situations",
          "clearly describe to clients and other professionals the content and availability of guidance and other services and forms of support",
        ],
      },
      {
        context: "Ohjaamo One-Stop-Guidance Centers",
        tunnistaa_ja_ymmartaa: [
          "the importance of communication and interaction competency required for multisectoral, multiprofessional and working life cooperation in their work",
          "the skills and readiness of clients of different ages and backgrounds to interact and receive communication and information",
        ],
        osaa: [
          "plan and implement interaction situations and communication, taking into account the skills and capabilities of clients of different ages and types",
          "act in multisectoral and multiprofessional interaction situations",
          "clearly describe to clients and partners the content and availability of guidance and other services and forms of support",
        ],
      },
    ],
  },
  "A5.1": {
    id: "A5.1",
    header: "Technology in guidance",
    text: "Career professionals utilise digital technology in guidance efficiently and appropriately.",
    tunnistaa_ja_ymmartaa: [
      "the role of digital technology in guidance work and its impact on the guidance process",
      "different digital tools and solutions that are relevant to the guidance process",
      "clients' varying needs and capabilities to use digital technology in guidance",
      "the importance of digital guidance materials´ accessibility",
      "opportunities and limitations of digital technology in guidance work",
      "the importance of data protection and privacy when using digital technology in guidance work",
      "the role of digital technology in supporting their professional development and its impact on expanding and updating their competency",
    ],
    osaa: [
      "choose the most appropriate digital tools and solutions for different guidance situations based on the client's or group's needs",
      "select and use digital guidance resources that are accessible ",
      "use digital technology to store data and protect client data in compliance with applicable data protection regulations and practices",
      "assess the impact of digital technologies in the guidance process and, if necessary, make changes to the technologies used to improve the quality of the guidance process",
      "use digital technology in the development of their professional expertise, for example, by participating in online training, following online content related to the field and participating in professional networks",
      "comply with the principles of data security and privacy in the use of digital technology and ensure the secure storage and protection of client data",
      "continuously develop their competency and keep up to date with technological development and its impact on guidance work by adapting their activities and methods to meet the opportunities and challenges posed by technology",
    ],
  },
  "A5.2": {
    id: "A5.2",
    header: "Technology in the guidance process",
    text: "Career professionals utilise digital technology seamlessly in the guidance process.",
    tunnistaa_ja_ymmartaa: [
      "how different digital tools and applications can support different guidance phases, such as data collection, goal setting and monitoring",
      "the special features and suitability of different digital interaction channels, such as video calls, chats and email, in guidance situations",
      "the importance of accessibility of digital guidance materials",
      "clients' different needs and preferences in the use of digital technology in guidance",
      "potentials and challenges of digital technology during the guidance process",
      "how to integrate digital technology seamlessly into guidance so that it supports the guidance process and the achievement of the client's or group's goals",
    ],
    osaa: [
      "select and utilise appropriate digital tools and applications for different phases of guidance process, guidance situations and client groups",
      "select and use digital guidance materials that are accessible",
      "use digital technology in data collection and analysis to better understand the client's situation and design guidance process",
      "provide clients with support and guidance in using digital technology if it is new or challenging for them",
      "apply good interaction skills and practices in the digital environment, such as clear and easy-to-understand communication, active listening and empathy",
      "assess the impact of digital technology in the guidance process and, if necessary, make changes to its use, content and methods",
      "create and maintain a digital environment that supports guidance pro-cess and the achievement of client goals",
      "keep digital technologies as part of the continuous development of their guidance process and adapt to technological changes",
    ],
  },
  "A5.3": {
    id: "A5.3",
    header: "Collaborative use of technology",
    text: "Career professionals promote the collaborative use of digital technology in the guidance process, enabling group-based guidance and peer support for clients and other stakeholders. They take advantage of the possibilities and tools of digital technology for professional collaboration to achieve common goals.",
    tunnistaa_ja_ymmartaa: [
      "how digital technology can be used to support collaborative guidance and peer learning, and how different technologies enable group-based interaction and information sharing",
      "how to create a safe and supportive environment for group-based use of digital technology",
      "how to take into account the varying capacities and needs of participants in the use of digital technologies",
      "how digital technology can progress group dynamics and community building during the guidance process",
      "the potential of digital technologies for professional collaboration to achieve jointly agreed goals",
    ],
    osaa: [
      "plan and implement collaborative guidance activities with the help of digital technology, selecting tools and methods according to the needs of the group",
      "provide guidance with the group in the use of digital technology and provide support to participants when needed ",
      "create a safe and open atmosphere that encourages participants to share their experiences and learn from each other",
      "apply good interpersonal skills and practices in the digital environment, such as clear and easy-to-understand communication, active listening and empathy",
      "utilise different facilitation methods to promote interaction in digital environments",
      "take different learning approaches into account and offer diverse learning opportunities utilising digital technology with a group",
      "monitor and evaluate the effects of the use of community-based, group-based digital technology on the guidance process and, if necessary, make changes in accordance with the set goals and the needs of the group",
      "take advantage of the possibilities and tools afforded by technology for professional collaboration to achieve jointly agreed goals",
    ],
  },
  "A5.4": {
    id: "A5.4",
    header: "Systematic development of using technology in guidance",
    text: "Career professionals utilise new technological solutions in the field and promotes their use in the guidance process.",
    tunnistaa_ja_ymmartaa: [
      "the rapid development of digital technology and its impact on guidance work",
      "how digital technology can enhance the guidance process and improve the quality of client service",
      "how to monitor and evaluate the impact of the use of digital technologies and make changes if necessary",
      "how integrating digital technology into guidance work can impact their professional development opportunities",
    ],
    osaa: [
      "monitor the development of digital technologies and stay aware of new technological solutions that can support the guidance process",
      "assess in their work how digital technology could improve the availability and quality of services",
      "develop their competency and actively acquire new technological skills, tools and applications",
      "listen to and take into account feedback from clients and colleagues on the use of digital technology and develop their work based on it",
      "keep up to date with the best practices in their field and share information about the efficient use of digital technology in guidance work with their colleagues",
    ],
  },
  "B1.1": {
    id: "B1.1",
    header: "Features of the guidance process",
    text: "Career professionals view guidance alongside the client's development and change process as a multiprofessional, multisectoral and multi-administrative service process and societal activity. The multichannel services used in guidance may include on-site visits, real-time or delayed remote service, video conferencing or telephone services.",
    tunnistaa_ja_ymmartaa: [
      "the different starting points and capabilities of individuals and groups to plan and make decisions concerning their future",
      "the different life experiences, life phases and different social and economic situations of individuals and groups as the starting point for guidance processes",
      "factors, preconditions and resources affecting the organisation and provision of guidance services",
      "the key stakeholders behind the organisation of guidance",
      "the role of guidance as part of education, economic, youth and social and health policies ",
      "common goals of different government sectors and policies concerning the organisation of guidance",
      "different service channels for the guidance provision",
    ],
    osaa: [
      "consider guidance as part of individuals’ and groups’ life processes ",
      "consider guidance as goal-oriented interaction situations",
      "consider guidance-related incidents in the context in which they occur",
      "consider guidance as an individual's subjective right",
      "conduct guidance work and produce guidance services through multiple channels in individual and collaborative processes that meet client needs",
    ],
  },
  "B1.2": {
    id: "B1.2",
    header: "Guidance as a process",
    text: "Career professionals take the information, interaction, and process dimensions of guidance into consideration. The information dimension concerns the individual's knowledge of themselves, the possibilities of the operating environment and the individual's relationship with their operating environment. The interaction dimension is related to building and maintaining a guidance relationship and a working alliance. The process dimension covers understanding the way of making decisions and the connections between the factors behind these decisions and the decisions made.",
    tunnistaa_ja_ymmartaa: [
      "the process nature of guidance in clients' independent work, staff-assisted work, individual and group guidance facilitated by career profes-sional, and collaborative processes in different contexts",
      "the importance of the content, interaction, and process dimensions of guidance",
      "the particular situation, readiness and needs of the client and groups as a whole as the starting point for guidance",
      "the difference between individual guidance sessions and long-term guidance processes",
      "the significance of the overall structure of the guidance process and its different phases ",
      "the differences in power dynamics between a career professional and their client and variation in their role depending on the forms of guidance",
    ],
    osaa: [
      "assess their clients’ and groups’ situation and service needs together with them ",
      "assess the client's initial situation and choose an appropriate approach and working method based on the situation, context and service needs of the client and the groups",
      "structure the client's situation and possibilities for action during the guidance into an understandable whole",
      "plan, implement, evaluate, manage, develop and renew guidance processes, taking into account the context, diversity of different client groups and backgrounds as an underpinning resource for guidance ",
      "agree with the client and the groups on a process for defining the goals and boundaries of guidance",
      "assess, together with the client and the groups, whether the guidance process is appropriate in relation to their situation, context and need for service",
      "work with the client and groups to create a shared understanding of the guidance process and how to achieve goals",
    ],
    context_competencies: [
      {
        context: "Basic education",
        tunnistaa_ja_ymmartaa: [
          "the goals set for guidance in the core curricula for comprehensive and upper secondary general education and in requirements for vocational qualifications, as well as the areas and operating models of guidance",
          "the goals and operating models of guidance and counselling described in the education provider's and the school's operational plan for guidance",
          "linkages between guidance and counselling and student welfare services and other school activities",
        ],
        osaa: [
          "construct a guidance process as a goal-oriented continuum that utilises different approaches and methods, such as classroom activities, group guidance, individual guidance, familiarisation with working life, site visits and multiprofessional and multisectoral collaboration plan and implement sessions in which students learn and acquire self-assessment skills",
          "assess pupils' needs for guidance and support by utilising various guidance methods and tools",
        ],
      },
      {
        context: "General upper secondary education",
        tunnistaa_ja_ymmartaa: [
          "the goals set for guidance in the core curricula for comprehensive and upper secondary general education and in requirements for vocational qualifications, as well as the areas and operating models of guidance",
          "the objectives and operating models of study counselling described in the education provider’s and upper secondary school’s operational plan for guidance",
          "linkages between guidance and counselling and student welfare services and other upper secondary school activities",
        ],
        osaa: [
          "construct a guidance process as a goal-oriented continuum that begins from enrolment to education and continues to completing the degree and, if necessary, even after studies as a bridge to enrolment for further education, organise guidance support for students who need personalised solutions in transition to upper secondary general or vocational education ",
          "collaborate with group tutors to achieve the goals of guidance in upper secondary school",
          "construct guidance process as a continuum that utilises different operating models, such as individual study plans drawn up by students, class-room activities, group and individual guidance, familiarisation with working life, site visits and multiprofessional and multisectoral cooperation",
          "plan and implement sessions in which students learn and acquire self-assessment skills",
          "assess students' needs for guidance and support by utilising various guidance methods and tools",
        ],
      },
      {
        context: "Vocational education and training",
        tunnistaa_ja_ymmartaa: [
          "the goals set for guidance in the core curricula for comprehensive and upper secondary general education and in requirements for vocational qualifications as well as the areas and operating models of guidance",
          "the objectives and operating models of guidance and counselling described in the guidelines of the education provider and educational institution",
          "linkages between guidance and counselling with student welfare services and other activities of the educational institution",
        ],
        osaa: [
          "construct a guidance process as a goal-oriented continuum that begins from enrolment to education and continues all the way to completing the degree",
          "collaborate with the teachers and other actors in order to achieve the objectives of guidance",
          "construct a guidance process as a goal-oriented continuum that utilises different approaches and methods, such as individual competency development plans, classroom activities, group guidance, individual guidance, work-based learning, site visits and multiprofessional and multisectoral collaboration to organise guidance support for students who need personalised solutions in transition to upper secondary general or vocational education ",
          "plan and implement sessions where students learn and acquire self-assessment skills",
          "assess students' needs for guidance and support by utilising various guidance methods and tools",
        ],
      },
      {
        context: "Higher education",
        tunnistaa_ja_ymmartaa: [
          "the objectives and contents set for guidance at the educational institution and the division of labour between professionals",
          "linkages between guidance and other student support services",
        ],
        osaa: [
          "construct a guidance process as a goal-oriented continuum that begins from enrolment to education and continues to the completion of the degree",
          "collaborate with academic tutors and other staff to achieve the goals of guidance",
          "construct a guidance process as a goal-oriented continuum that utilises different approaches and methods, such as individual learning plans, group guidance, individual guidance, work-based learning, site visits, career guidance, and multiprofessional and multisectoral collaboration plan and implement sessions in which students learn and acquire self-assessment skills ",
          "assess students' needs for guidance and support by utilising various guidance methods and tools",
        ],
      },
      {
        context: "Employment services",
        tunnistaa_ja_ymmartaa: [
          "target groups and supply of employment services",
          "the connection between clients' health factors or limitations and work ability and employability",
          "forms of support and services available to clients",
        ],
        osaa: [
          "cooperate with other personnel to achieve the goals of guidance",
          "cooperate with outsourced support services",
          "utilise existing tools to assess clients' situations, service needs and employability",
          "identify clients' capabilities and, if necessary, arrange work ability examinations or other expert assessments in order to investigate different work, entrepreneurship and education options and to specify their career plans",
          "identify psychological or other barriers to employment and work through these in a goal-oriented approach",
          "construct a guidance process as a goal-oriented continuum that utilises different operating models, such as clients' employment plans, job coaching, job search and career coaching, career guidance, work and training trials, as well as multiprofessional and multidisciplinary cooperation",
          "provide guidance with clients to identify and articulate their skills in order to enhance their employability",
          "use psychological assessment methods and tasks with the client's consent as part of the guidance process (applies only to licensed psychologists)",
          "guide people with partial work ability in finding employment",
          "inform clients on the range of services and forms of support available, where appropriate ",
        ],
      },
      {
        context: "Ohjaamo One-Stop-Guidance Centers",
        tunnistaa_ja_ymmartaa: [
          "client groups and key features of Ohjaamo One-Stop-Guidance Centers ",
          "forms of support and service provision available to their clients",
        ],
        osaa: [
          "construct a guidance process as a goal-oriented continuum that utilises multisectoral cooperation",
          "collaborate with teachers and other actors in educational institutions to achieve the goals of guidance",
          "inform clients on the range of services and forms of support available, where appropriate",
        ],
      },
    ],
  },
  "B1.3": {
    id: "B1.3",
    header: "Outcomes and impact of the guidance process",
    text: "Together with the client, the career professionals systematically evaluate the result and impact of the guidance process. The evaluation focuses on the process and the outcomes, skills achieved and observed changes in the client's situation. The evaluation of outcomes and impact requires continuous evaluation of the guidance process in terms of how the process proceeds, how the career professionals commit to the provision and development of the service, how the guidance meets the needs of the user groups, how clients participate in the process and its planning, how effective the guidance relationships and operating models used are, and how the evaluation findings are utilised in the development of services.",
    tunnistaa_ja_ymmartaa: [
      "the significance of evaluating the outcomes and impact of individual guidance processes from the perspective of developing their work",
      "the significance of the evaluation of the result and impact of guidance processes from the individual's perspective",
      "factors having an impact on the outcomes of the guidance process, such as context, the client's life situation, social networks and available services",
      "methods and criteria for evaluating the outcomes and impact of the guidance process",
      "how to define assessment targets and criteria for verifying the outcomes and impact of guidance processes",
      "the outcomes of the guidance process, the development of the client's skills and changes in the situation",
    ],
    osaa: [
      "define the goals of the guidance process together with the cli-ents/groups and monitor their realisation",
      "gather feedback from clients/groups both during and at the end of the guidance process",
      "provide guidance with clients/groups to evaluate their development and the development of their skills and competency during the guidance process",
      "specify or redefine the goals of guidance based on feedback and information gained from evaluation ",
      "improve their activities as a career professional based on the outcomes and feedback",
      "analyse and evaluate guidance processes and methods, their professional practices and their quality and impact",
    ],
  },
  "B2.1": {
    id: "B2.1",
    header: "Developmental and life span theories",
    text: "Career professionals examine guidance from the individual's perspective separately as a development process, life situation and its context.",
    tunnistaa_ja_ymmartaa: [
      "the context of the interconnectedness of theories of individual development and the course of life and the era in which they were developed",
      "how theoretical knowledge related to individual development and life span is applied in the guidance process",
      "the influence of context, client's life situation, interpersonal relationships and personal factors in the guidance process and the achievement of goals",
      "the knowledge base of factors affecting inclusion and social exclusion ",
      "factors affecting well-being, functional capacity and agency",
      "factors that influence emotional, social, cultural, and cognitive development",
      "factors affecting learning and the development of one's competency",
    ],
    osaa: [
      "choose an appropriate theoretical approach for the situation",
      "apply key theories related to individual development, life span and context in guidance work",
      "take individual phases of development and individual differences in mental, physical and social development into consideration",
      "apply research and theoretical knowledge on inclusion and social exclusion in guidance work",
      "utilise research and theoretical knowledge on individual learning, behaviour, identity, physical, mental and social well-being and agency in guidance work ",
    ],
  },
  "B2.2": {
    id: "B2.2",
    header: "Career development theories",
    text: "Career professionals examine career development within the framework of individual characteristics, interests and values. Career development can also be described as a process influenced by historical time, economy, and the general conditions in society, as well as the individual's sphere of life and relationships.",
    tunnistaa_ja_ymmartaa: [
      "time and context constraints of career theories",
      "essential career development theories",
      "the connection of career development with the course of human development and life",
      "factors influencing career development in an individual's social relationships, life situation and networks",
      "areas of career management skills and the significance of their acquisition in the client's life and career planning",
      "the variety and significance of transitions and transitional phases in an individual's life course",
      "factors affecting employability and employment",
    ],
    osaa: [
      "critically examine the approaches and applicability of different career development theories to the guidance process",
      "apply career development theories appropriate to the needs of an individual or group",
      "take into account contextual, relational and individual factors related to career planning during the guidance process",
      "provide guidance in acquiring career management skills",
      "provide guidance during and through transitions",
      "provide guidance in acquiring employability skills",
    ],
  },
  "B2.3": {
    id: "B2.3",
    header: "Society and working life",
    text: "Career professionals examine guidance work as part of a social and cultural reality that affects the clients' situation and opportunities to construct their lives and careers equally and sustainably. In addition to the individual's own goals and guidance needs, the organisation of guidance is influenced by social, health and rehabilitation policy objectives, as well as educational and labour market policy objectives. As working life and individuals are constantly evolving, guidance requires a dynamic understanding of society and people's opportunities to learn along with this change.",
    tunnistaa_ja_ymmartaa: [
      "essential operating principles of society and the labour market",
      "the impact of societal structures and operating systems on their work",
      "the impact of global economic factors on the labour market",
      "the importance of anticipation and futures’ literacy in their work",
      "various signals that anticipate changes ",
      "the impact of changes in their operating environment ",
      "the interface between client interests and the labour market",
      "the social functions of the education system and the role and function of guidance in it",
      "the impact of current international and national trends on the functional capacity of clients and organisations, as well as on life and career planning",
      "the importance of guidance in the realisation of equity and equality in society",
      "the importance of guidance in the realisation of social inclusion and a sustainable lifestyle in society",
    ],
    osaa: [
      "critically examine the societal trends",
      "consider how economical and other factors affecting people’s lives are impacting their plans regarding their life and career",
      "examine socially constructed differences and power relations in education and working life",
      "take into account the impact of changes in working life on individuals' careers, skills needs and mobility",
      "utilise anticipation and future literacy in their work",
      "promote the realisation of equity and equality",
      "take factors that strengthen a sustainable lifestyle into account in guidance",
      "provide their clients with guidance when planning their education and careers in international contexts",
    ],
  },
  "B2.4": {
    id: "B2.4",
    header: "Guidance theories",
    text: "Career professionals apply guidance theories, taking into account the individual and their context in a client-oriented manner. Competency relating to guidance theories provides the career professional with a foundation for creating goal-oriented enabling and learning processes. In addition, through theoretical competency, the career professionals construct guidance as an encounter, working methods and dialogue used in various interpersonal professions.",
    tunnistaa_ja_ymmartaa: [
      "the underpinning theories of the methods and tools used in guidance, and their time and context constraints",
      "approaches to building and maintaining a guidance relationship ",
      "approaches and methods to help clients strengthen their agency, well-being and career management skills",
      "theories related to individual guidance",
      "theories related to group formation, group membership and group activities",
      "the importance of screening clients' readiness and guidance needs from the perspectives of the outcome and impact of the guidance process",
      "the client's career management skills are influenced by individual, relational and contextual factors",
      "the importance of clients´ cultural background in career planning and the guidance process",
    ],
    osaa: [
      "describe and justify how they plan, implement and evaluate guidance and guidance processes by applying guidance theories and models",
      "evaluate the suitability of the chosen theory of use in relation to the client's needs and situation",
      "evaluate the applicability of their theory of use to the respective guidance process ",
      "provide guidance in acquiring career management skills by utilising various guidance methods and tools in a versatile way",
      "provide guidance in finding employment and at different phases of job search by utilising various methods and tools in a versatile way",
    ],
  },
  "B2.5": {
    id: "B2.5",
    header: "Lifelong and continuous learning",
    text: "Career professionals ensure that in the learning process related to career planning, clients and groups learn to assess and develop their strengths and competency in relation to the opportunities provided by the operating environment. The guidance process highlights transversal skills that enable individuals to observe changes in their operating environment, specify learning targets for themselves, develop their resilience and actively produce change and development in their own lives and careers.",
    tunnistaa_ja_ymmartaa: [
      "the importance of lifelong competency development and lifelong learning in an individual's lifespan",
      "career planning as a lifelong continuum of and as a learning process",
      "career management skills as independent, learnable transversal competency ",
      "the importance of career management skills in different life situations and transitions",
      "essential theoretical knowledge and research related to learning",
      "factors and operating models related to the recognition and validation of prior learning ",
      "factors affecting clients' learning ability, resilience and well-being, neuropsychological challenges and their impact on learning, competency development, career planning and the implementation of plans",
      "identify the impact of the client's previous study experiences on career planning and the implementation of plans",
      "the importance of general working life skills in career planning and employment",
    ],
    osaa: [
      "apply functional and problem-based working methods in guidance",
      "create functional and problem-based learning situations that enable clients to acquire their career management skills and provide guidance with clients in acquiring their self-assessment skills so that they are able to describe their strengths, competency and areas for development",
      "provide guidance with the client in acquiring their study and self-regulation skills",
      "support clients in using digital technology and developing information retrieval skills",
      "identify common problems related to learning and study skills and, if necessary, refer the client to learning support services",
      "provide guidance with clients to act to achieve their plans and goals",
      "provide guidance with clients to acquire self-reflection and self-assessment skills so that they are able to analyse their learning process and the development of their transversal skills",
    ],
  },
  "B2.6": {
    id: "B2.6",
    header: "Guidance philosophy",
    text: "Career professionals examine their own and the client's worldview as conceptualisation, awareness and structuring of the interpretation of reality. The goal is to strengthen the individual's self-knowledge and structure the underpinning foundations and beliefs of life. Philosophical questions of guidance are linked to the ethical principles of guidance.",
    tunnistaa_ja_ymmartaa: [
      "the connections between guidance philosophical perspectives and their guidance orientation",
      "different worldview dimensions and contents",
      "the connection between philosophical questions of guidance and ethical principles",
    ],
    osaa: [
      "define one's worldview and concept of humanity and their impact on one's guidance orientation",
      "respect the client's worldview and values",
      "provide guidance with the client in defining their values and thereby im-proving their self-knowledge",
      "critically examine the world and the future, as well as the values prevailing in society",
      "provide guidance with the client in acquiring critical reflection skills",
    ],
  },
  "B3.1": {
    id: "B3.1",
    header: "Information retrieval and management",
    text: "Career professionals ensure that both they and the clients and groups have access to up-to-date sources of information to support making plans and decisions concerning life, studies, and work. Career professionals ensure that clients and groups acquire the necessary skills to retrieve, evaluate and uti-lise information when making plans and choices concerning their lives.",
    tunnistaa_ja_ymmartaa: [
      "up-to-date and reliable sources of information that they can utilise in their work",
      "quality criteria with which to evaluate the reliability of the information and information sources being used",
      "the importance of up-to-date labour market information in guidance ",
      "sources of information containing up-to-date information on education and employment options",
      "sources of information on entrepreneurship",
      "sources of information on available forms of support",
      "essential sources of information on other services available",
    ],
    osaa: [
      "choose up-to-date, reliable and suitable resources",
      "seek information on training opportunities and related enrolment procedures",
      "seek information on employment options and different forms of work as well as procedures regarding job-seeking",
      "seek information on entrepreneurship",
      "seek information on existing forms of support available to clients",
      "provide guidance with the client in information retrieval, evaluation and use of information",
    ],
  },
  "B3.2": {
    id: "B3.2",
    header: "Reflecting and setting goals",
    text: "Career professionals build a confidential guidance relationship. Career professional screen the client's or group's readiness and guidance needs and sets the goals for the guidance process together with the client or group members.",
    tunnistaa_ja_ymmartaa: [
      "the importance of building a guidance relationship in the early phases of the guidance process and screening the need for guidance",
      "the multidimensional nature of career management skills",
      "the client’s personal goals that are having an impact on the guidance situation and the instructions and objectives related to the core task of their organisation ",
      "the guidelines and statutory documents used in the organisation for drawing up the client's development plan",
      "the importance of multiprofessional and multisectoral cooperation during the guidance process",
    ],
    osaa: [
      "identify the client's personal goals as well as the normative and administrative objectives related to the organisation's core task that apply to all client groups",
      "assess the client's or group's career management skills, competency level and areas for development",
      "utilise various tools and methods in screening the readiness and guidance needs of clients and groups",
      "build a confidential guidance relationship",
      "provide guidance with the client or group in acquiring self-knowledge and self-assessment skills",
      "provide guidance with the client in identifying and articulating their competency",
      "set goals for the guidance process together with the client or groups",
      "negotiate with clients and groups about the ways of working, methods and service channels to be used during the guidance process",
      "engage in multiprofessional and multisectoral cooperation when necessary",
      "identify and articulate the boundaries of their profession and competency ",
    ],
  },
  "B3.3": {
    id: "B3.3",
    header: "Client-centered guidance process",
    text: "Career professionals plan and implement the guidance process together with the clients. The objectives and operating models of the guidance process are based on the readiness and needs of the client or group. Career professionals monitor and evaluate how the guidance process proceeds according to the operating models and goals agreed with the client or group. They also monitor and evaluate how the goals are reached together with their clients.",
    tunnistaa_ja_ymmartaa: [
      "the individual background and readiness of clients and groups to plan their future and career",
      "the nature of the process related to career planning and decision-making, its phases and related factors",
      "client-centered approach in guidance",
      "the importance of monitoring and evaluating the objectives set for the guidance process and the progress of their implementation ",
      "the importance of utilising diverse and appropriate interventions, activities, and methods",
      "the importance of gathering feedback at the end of the guidance process",
    ],
    osaa: [
      "provide guidance with the client or group by applying appropriate methods, tools and service channels ",
      "document the progress of the guidance process",
      "apply career development theories appropriately during the guidance process",
      "assess how the guidance process is progressing in order to achieve the objectives",
      "assess whether the objectives set should be reviewed during the guidance process",
      "choose forms of work in which clients are active participants",
      "choose interventions and tools that help clients and groups strengthen their agency and skills for independent work",
      "cooperate, where appropriate, with educational institutions, working life and other parties and stakeholders",
      "ensure that the used resources and sources of information are up-to-date and reliable",
      "provide guidance with the client and groups to broaden their perspectives and perceptions of existing options available to them",
      "provide guidance with clients and groups to assess the applicability of different options available for them",
      "provide guidance with clients and groups to develop their decision-making skills",
      "provide guidance with clients and groups to implement their plans and take the necessary concrete measures",
      "provide guidance with clients and groups to develop skills needed in transitions",
      "complete the guidance process and gather feedback on the client's or group's experiences during the process",
      "develop their working methods based on feedback and information gained from evaluation",
    ],
  },
  "B3.4": {
    id: "B3.4",
    header: "Evaluation",
    text: "Together with the client, career professionals evaluate the result and impact of the guidance process. The evaluation covers learning outcomes and career management skills acquired through guidance, changes in functional capacity, well-being, agency, competency, as well as one's own life situation and career development. In addition, the evaluation focuses on what the individual has learned from the guidance process and how they utilise this competency in the future.",
    tunnistaa_ja_ymmartaa: [
      "the qualitative and quantitative outcomes of guidance and its impact on the individual",
      "the principles of documenting a guidance process",
      "the importance of evaluating the guidance process and the realisation of its goals",
      "evaluating the outcomes of individual guidance processes as part of the monitoring of the overall quality and impact of the organisation's operations",
    ],
    osaa: [
      "identify the qualitative and quantitative outcomes and impact of the guidance process, as well as the evaluation targets, data sources and criteria needed to demonstrate these",
      "document the progress of the guidance process and utilise documentation as evidence for evaluation of the guidance process",
      "use the necessary qualitative and quantitative forms and methods to assess the result and impact of an individual guidance process",
      "identify how clients and groups have achieved their goals",
      "provide guidance with clients and groups to evaluate the changes and outcomes they have experienced during the guidance process and the career management skills they have acquired",
      "develop their working methods based on information gained from evaluation",
    ],
  },
  "C1.1": {
    id: "C1.1",
    header: "Guidance in society",
    text: "Career professionals identify phenomena, relationships, trends, and changes between education, working life and society and utilises foresight information concerning the future in their work. In addition, they have the skills to promote guidance that is aware of societal structures and a sustainable, equal, fair, and diverse society.",
    tunnistaa_ja_ymmartaa: [
      "the phenomena, relationships, trends, changes and foresight information between education, working life and the society",
      "guidance as part of society's service structures",
      "the systemic significance of guidance for individuals, communities, service providers and societal development",
      "the importance of guidance for education policy, labour market, social inclusion, economic development, and sustainable future",
      "the importance of promoting equality, social justice and social diversity in guidance ",
      "how their job relates to the national policy goals for lifelong learning and skills development",
    ],
    osaa: [
      "obtain and evaluate up-to-date information on education, working life and social issues",
      "take into account, in guidance processes, anticipation and forecasts on the future of working life and society",
      "promote guidance that is aware of societal structures and an equal, fair and diverse society",
      "follow research and public discussion related to the organisation of guidance",
      "locate the position and role of guidance services as part of the national guidance ecosystem",
      "promote the planning and implementation of research related to their work and its operating conditions ",
      "participate in the formulation of policies concerning their work and its operating conditions",
    ],
  },
  "C1.2": {
    id: "C1.2",
    header: "Lifelong nature of guidance",
    text: "Career professionals ensure that the core of lifelong learning, is functional, client-centered, ethically sound and professionally and systemically produced lifelong guidance services at all phases of individual and group study and career paths.",
    tunnistaa_ja_ymmartaa: [
      "guidance as a continuum at all phases of an individual's life",
      "the systemic significance of guidance for individuals, communities, service providers and societal development",
      "the status and significance of guidance as part of the lifelong learning and competency development of individuals, groups and communities",
      "the role of guidance as a theme that permeates and unites different administrative sectors",
      "the special contexts of different administrative sectors and the rationales for organising guidance",
      "the national and international principles for organising multi-administrative and multisectoral guidance",
      "the principles and forms of guidance services of different administrative sectors, which create a foundation for mutual cooperation and peer learning",
      "their task as part of local and national lifelong guidance services",
    ],
    osaa: [
      "take into account the life situation of the client and groups as part of lifelong learning",
      "work with various client groups in different life situations",
      "ensure a seamless service chain during client transitions",
    ],
  },
  "C1.3": {
    id: "C1.3",
    header: "Position and positioning guidance",
    text: "Career professionals follow current research and participates in social discussions related to the field. Demonstrating the importance and added value of lifelong guidance in achieving the objectives of key education, employ-ment, economic and wellbeing and rehabilitation policies requires dialogue between career professionals and policy makers.",
    tunnistaa_ja_ymmartaa: [
      "the systemic significance of guidance for individuals, groups, communities, service providers and social development locally, nationally and internationally",
      "the importance of guidance in promoting equity and equality and a sustainable lifestyle",
      "decision-making processes concerning the guidance systems and policy development",
      "key policy-makers responsible for guidance systems and policy development and their areas of responsibility",
      "the significance of evaluation and research data on guidance and its outcome and impact as a basis for decision-making on guidance systems and policy development",
    ],
    osaa: [
      "identify the features of the guidance process in order to describe the position and core task of guidance to clients, collaborative partners, different stakeholders and policy-makers",
      "actively follow societal developments and current debate as well as multidisciplinary research from the perspective of guidance",
      "take into account the promotion of equity, equality and a sustainable lifestyle in guidance",
      "take into account the personal goals set by individuals for their lives and activities, as well as the objectives of the functional education system and working life",
      "demonstrate to policy-makers and service financiers the added value of guidance and the social return of investments in the implementation of guidance services",
      "identify evidence-based key targets for guidance systems and policy development",
      "identify the necessary measures and solutions to support evidence-based guidance systems and policy development ",
      "participate in public discussion on guidance systems and policy development",
      "include research-based information and evaluation findings as a basis for decision-making on lifelong guidance systems and policy development",
      "participate in the development of a regional operating model for guidance",
      "work with local, national and international partners to promote the objectives and operating conditions of guidance",
    ],
  },
  "C2.1": {
    id: "C2.1",
    header: "Organisations and networks",
    text: "Career professionals apply organisational and network theories in defining the common goals of guidance and in planning, implementing, and evaluating services. Career professionals work in multisectoral networks and pro-mote the continuity and consistency of services at different phases of an individual's life.",
    tunnistaa_ja_ymmartaa: [
      "the communal nature of entities and organisations providing guidance services ",
      "factors that promote or limit the activities of the organisation, networks and different actors in achieving jointly agreed goals",
      "how the tasks of the organisation and the network are divided between different actors",
      "how the structures of organisations and networks (power, leadership, division of responsibilities) affect the organisation of guidance",
      "how the operating cultures of the organisation and networks (operating methods, values, rules, language and relationships between actors) affect the organisation of guidance",
      "how organisations create the conditions for the provision of guidance services and the social interaction required in their operations",
      "how organisations and networks are a part of the lifelong guidance ecosystem (objectives, regulations, resources, activities and rationale)",
    ],
    osaa: [
      "understand both their and their organisation's role and position in networked guidance provision",
      "understand the effects of organisational and network structures and operating methods on the organisation of guidance",
      "apply organisational and network theories in defining jointly agreed goals for guidance as well as for planning, implementing and evaluating guidance",
    ],
  },
  "C2.2": {
    id: "C2.2",
    header: "Strategic learning",
    text: "Career professionals view lifelong guidance as part of an individual's life planning as well as a part of broader societal context and the service structure of different organisations. The organisation and development of guidance are separately connected to the societal function of guidance, the ac-tivities of organisations providing services, the competency of the guidance staff as well as to the guidance processes between individuals, groups, and career professionals. The learning of career professionals and their cooperation networks is based on the joint learning of the network members. In networks, jointly planned activities can bring positive changes to both career professionals and the cooperation networks.",
    tunnistaa_ja_ymmartaa: [
      "the principles and significance of systemic thinking for the planning and implementation of guidance services",
      "the role and significance of strategic learning for the continuous development of their work and their cooperation networks",
      "the essential approaches to strategic development",
    ],
    osaa: [
      "identify the drivers of change in the operating environment affecting their work together with the actors and stakeholder groups involved in organising guidance",
      "view guidance in the context in which it is provided",
      "take into account the connections between the different features of guidance",
      "identify the current state of the guidance provision and its key needs for change",
      "evaluate the guidance service process and use the evaluation findings in guidance systems and policy development",
    ],
  },
  "C3.1": {
    id: "C3.1",
    header: "Multiprofessional networking",
    text: "Career professionals work in multiprofessional cooperation with other professionals at different phases of individual and group guidance processes. The areas that require a division of labour in guidance are support for functional capacity and well-being, skills development and career development and life planning.",
    tunnistaa_ja_ymmartaa: [
      "various parallel perspectives and background factors that are affecting guidance situations",
      "different concepts used by different organisations to describe guidance work",
      "guidance as a continuum and a networked service",
      "operational plans for the guidance provision both in their organisation and in collaborative partner organisations, as well as jointly agreed overall goals for guidance",
      "the responsibilities, resources, competency areas and tasks of different career professionals in local collaborative networks",
      "their role and position in networking at different phases of the guidance process for individuals or groups",
      "boundaries of their profession and competency in guidance work",
    ],
    osaa: [
      "examine client situations from multiple perspectives",
      "interact with career professionals working in different administrative sectors as peers",
      "respect different perspectives in guidance and tolerate ambiguity in the guidance situations",
      "articulate underpinning concepts and principles concerning their work",
      "compile a common understanding from different perspectives as a foundation for multiprofessional work",
      "establish appropriate collaborative relations",
      "work in various multiprofessional working groups and cooperation networks and agree upon referring their client to another service provider in their network if necessary",
      "during multidisciplinary cooperation ensure that responsibility for the client's guidance process is clearly defined between the actors",
      "identify the significance of multiprofessional cooperation for the development of guidance activities in their organisation",
    ],
  },
  "C3.2": {
    id: "C3.2",
    header: "Multisectoral networking",
    text: "Career professionals cooperate with other organisations providing guidance services to develop regional multisectoral guidance services and share good practices. Multisectoral cooperation examines the relationship networks of organisations and stakeholders providing guidance services, the differences between organisations' tasks and relationships, and the interface of services and jointly provided collective services. In multisectoral networking, career professionals cooperate with actors and stakeholders in different administrative sectors at different phases of individual and group guidance processes.",
    tunnistaa_ja_ymmartaa: [
      "the importance of the jointly agreed overall goals for regional guidance services",
      "the importance of mutual agreement and knowledge formation",
      "regional service user groups and region-specific demand and need for guidance",
      "partners and stakeholders and their possible expectations regarding the outcomes of guidance",
      "key stakeholders and service providers responsible for organising guidance and their areas of expertise",
      "special characteristics of local guidance service providers in the need for referrals",
      "their organisation’s core tasks and its boundaries in a regional multidisciplinary guidance service network",
    ],
    osaa: [
      "contribute to the formation of the cooperation network for organisation of regional guidance services",
      "contribute to the organisation of the regional collaborative or working groups to achieve jointly agreed goals for the services",
      "plan and implement their work in a multisectoral network, taking into account the objectives of both their organisation and the region's multisectoral network for guidance provision",
      "create an action plan for guidance work in their organisation as part of a regional cooperation network ",
      "agree on the responsibilities of each actor in the network",
      "ensure sufficient mandate to operate in the network",
      "agree on underpinning principles for mutual communication and exchange of information",
      "agree, with the client about transferring them to another actor within the service network if necessary ",
      "ensure that responsibility for the client's guidance process is clearly de-fined between the actors in multisectoral cooperation",
      "improve their competency in networking and cooperation skills",
      "promote communal activities in networks ",
    ],
  },
  "C4.1": {
    id: "C4.1",
    header: "Planning and organisation",
    text: "Career professionals plan and organises their work in accordance with the ethical principles of the field, quality criteria, local needs, and operating conditions, as well as legislation, administrative guidelines and regulations that impact professional practice.",
    tunnistaa_ja_ymmartaa: [
      "the importance of strategic competency in guidance work",
      "legislation, regulations and administrative instructions that impact professional practice",
      "various user groups of services",
      "guidance as part of the organisation's overall operations and its operating culture",
      "their work as part of the regional and local lifelong guidance ecosystem",
      "available resources and multisectoral overall resources for the provision of services",
      "the basis for the most appropriate and efficient use of existing multisectoral overall resources",
    ],
    osaa: [
      "draw up an action plan as a basis for their work",
      "identify the essential user groups for guidance services in their administrative sector",
      "carry out an assessment of service needs among different user groups",
      "plan guidance and guidance services as part of their organisation's operations",
      "plan guidance and guidance services as part of the services of regional cooperation networks",
      "create a culture of trust and openness in their work community as a basis for cooperation",
      "proactively develop guidance and guidance services ",
    ],
    context_competencies: [
      {
        context: "Comprehensive and upper level secondary education",
        tunnistaa_ja_ymmartaa: [
          "the basics of school level legislation, curriculum, and qualifications",
          "other administrative guidelines and instructions concerning the level of education",
          "institutional strategic and operational plan for guidance provision",
        ],
        osaa: [
          "plan, implement and evaluate guidance in accordance with legislation concerning the level of education and the administrative guidelines, curricula and qualification criteria guiding the activities",
          "plan, implement and evaluate in accordance with institutional strategic and operational plan for guidance provision",
        ],
      },
      {
        context: "Higher education ",
        tunnistaa_ja_ymmartaa: [
          "higher education legislation, administrative guidelines, and qualification criteria",
          "institutional strategic and operational plan for guidance provision",
        ],
        osaa: [
          "plan, implement and evaluate guidance in accordance with higher education legislation and administrative guidelines",
          "plan, implement and evaluate guidance according to the institutional strategic and operational plan for guidance provision",
        ],
      },
      {
        context: "Employment services",
        tunnistaa_ja_ymmartaa: [
          "legislation and national and regional guidelines on the operation of employment services",
          "common operating principles, plans and guidelines of their own organisation",
        ],
        osaa: [
          "plan, implement and evaluate guidance services in accordance with legislation and administrative and organisational guidelines of the employment services",
          "respect the right of individuals to self-determination and autonomy in harmony with other normative obligations of the employment services",
        ],
      },
      {
        context: "Ohjaamo One-Stop-Guidance Centers",
        tunnistaa_ja_ymmartaa: [
          "legislation on the operation of Ohjaamo One-Stop-Guidance Centers and national and regional guidelines",
          "common operating principles, plans and guidelines of their own organisation",
        ],
        osaa: [
          "design, implement and evaluate guidance services in accordance with national, regional and organisational guidelines",
        ],
      },
    ],
  },
  "C4.2": {
    id: "C4.2",
    header: "Quality assessment and monitoring",
    text: "Career professionals promote the systematic evaluation of the quality and impact of guidance. The evaluation of the quality and impact of guidance covers the outcomes of services, service implementation and service process, service structures, total resources allocated for the implementation of guidance, as well as the entire approach to quality assessment and the organisation´s quality culture.",
    tunnistaa_ja_ymmartaa: [
      "the outcomes, impact, and quality of guidance from the perspectives of society, service providers and clients",
      "key quantitative and qualitative approaches and tools for quality assessment",
      "various user groups and their needs for guidance services",
      "how well guidance meets demand and the needs of individuals, groups and different stakeholders",
      "how well individuals and groups are progressing towards the set goals",
      "how accessible guidance services are for all user groups",
      "the effectiveness of client relationships",
      "how clients experience the service",
      "how the services are being managed",
      "key criteria for high-quality guidance",
      "how to act in collaborative networks to develop guidance and its quality",
      "how to document guidance processes and their outcomes as an evidence for knowledge-based management",
      "how competency and activities impact the overall quality of guidance",
    ],
    osaa: [
      "identify the key outcomes of their work from the perspectives of the individual, their organisation and society",
      "identify the necessary quantitative and qualitative criteria, as well as the necessary evidence to demonstrate the outcomes of guidance",
      "design forms of work in which the possible outcome of guidance can be documented",
      "document the effectiveness and impact of their own work",
      "systematically collect quantitative and qualitative data on the implementation of guidance",
      "interpret information on the guidance provision from the perspective of the quality and impact of services",
      "combine information on the guidance provision with other available research and evaluation data",
      "develop their work on the basis of the evaluation results",
      "disseminate evaluation data to be used as a basis for the systematic development of guidance work to colleagues, researchers and policy-makers",
      "follow research in the field, which can be applied to the development of their own work",
    ],
  },
  "C4.3": {
    id: "C4.3",
    header: "Continuous development",
    text: "Career professionals examine the underpinning principles, values, perceptions, structures, policies and practical prerequisites of the guidance systems and policies. The continuous development of guidance services based on strategic learning covers the evaluation and analysis of services, visioning, communication and operations, and continuous learning of services.",
    tunnistaa_ja_ymmartaa: [
      "the impact of global and societal trends and changes on the economy and working life",
      "how changes in society determine the guidance systems and policy development",
      "the needs of different client groups and stakeholder expectations that affect the guidance systems and policy development",
      "key theories, values, national policies and regulations related to guidance systems and policy development",
      "key stakeholder groups involved in the organisation of guidance",
      "policy-making and decision-making processes concerning the organisation of guidance",
      "the overall resources available for the organisation of guidance",
      "key elements of multisectoral guidance systems ",
    ],
    osaa: [
      "take into account the key elements and mechanisms of the guidance process in their development work",
      "obtain and evaluate up-to-date information on education, working life and social issues",
      "prepare an assessment of the current situation in their operating environment",
      "critically evaluate and utilise anticipation data",
      "identify the key trends and external drivers for change related to guid-ance systems and policy development",
      "understand their own and their community’s role in building the future",
      "identify the strengths and development areas of their own and the collaborative network's operations",
      "use client feedback and evaluation findings in replanning and developing their own and their cooperation network's operations",
      "draw up an action and development plan for their work as well as measurable indicators for its goals",
      "participate in the continuous development of the cooperation network and in the construction of a joint action plan",
      "contribute to the organisation of the work of the cooperation network with a view to achieving jointly agreed goals",
      "act proactively to ensure overall collective resources and mandate",
      "systematically document and report the outcomes of networking in accordance with jointly agreed principles",
      "establish new forms of work and their systematic evaluation as a basis for their own continuous learning and professional development",
    ],
  },
};
